module.exports = __webpack_public_path__ + "img/smart_tasting.b13fbc71.png";